import { computed, action, observable, makeObservable } from "mobx";
import { createBetsChunks, Tracker } from "../../../helpers";
import { telemetry } from "../../../constants";
export class MyBetsListState {
    constructor(options) {
        this.activate = () => {
            this.parser.activate();
        };
        this.deactivate = () => {
            this.parser.deactivate();
            this.chunkHeights.clear();
            this.betCardData.clear();
        };
        this.openEarlyExitTagModal = () => {
            this.openEarlyExitModal();
        };
        this.changeStatusFilter = (index) => {
            const status = this.config.statusFilterKeys[index];
            if (typeof status !== "undefined") {
                this.selectedStatusFilterIndex = index;
                this.chunkHeights.clear();
                this.parser.clearBets();
                this.parser.loadMoreBets({
                    status,
                    previousStatus: this.config.statusFilterKeys[this.selectedStatusFilterIndex],
                    count: this.config.loadBetsCount,
                    toggleCashOutSubscriptions: true,
                    action: telemetry.actions.myBets.openTab,
                });
            }
        };
        this.loadMoreBets = () => {
            const status = this.config.statusFilterKeys[this.selectedStatusFilterIndex];
            if (typeof status !== "undefined" && this.status !== "Loading") {
                this.parser.loadMoreBets({
                    status,
                    previousStatus: status,
                    count: this.config.loadBetsCount,
                    toggleCashOutSubscriptions: false,
                    action: telemetry.actions.myBets.loadMoreBets,
                });
            }
        };
        this.hasMoreBetsToLoad = () => this.status === "Initial" || this.status === "Loaded";
        this.openLogin = () => {
            Tracker.getInstance().trackEvent(telemetry.events.myBets, {
                Action: telemetry.actions.myBets.routeToLogin,
                ClientType: telemetry.clientType,
                CurrentTab: this.config.statusFilterKeys[this.selectedStatusFilterIndex],
                MyBetsVersion: telemetry.version,
            });
            this.config.openLogin();
        };
        this.openGameLines = () => {
            Tracker.getInstance().trackEvent(telemetry.events.myBets, {
                Action: telemetry.actions.myBets.routeToSportsbook,
                ClientType: telemetry.clientType,
                CurrentTab: this.config.statusFilterKeys[this.selectedStatusFilterIndex],
                MyBetsVersion: telemetry.version,
            });
            this.config.openGameLines();
        };
        this.dictionary = options.dictionary;
        this.config = options.config;
        this.parser = options.parser;
        this.selectedStatusFilterIndex = 0;
        this.chunkHeights = observable.map(new Map());
        this.betCardData = observable.map(new Map());
        this.shareBet = options.config.shareBet;
        this.getNavLink = options.getNavLink;
        this.getIcon = options.getIcon;
        this.openEarlyExitModal = options.openEarlyExitModal;
        makeObservable(this, {
            selectedStatusFilterIndex: observable,
            status: computed,
            betsChunks: computed,
            changeStatusFilter: action,
            loadMoreBets: action,
            hasMoreBetsToLoad: action,
            setActualChunkHeight: action.bound,
            setIsExpanded: action.bound
        });
    }
    get status() {
        return this.parser.status;
    }
    get betsChunks() {
        return createBetsChunks({
            bets: this.parser.bets,
            chunkHeights: this.chunkHeights,
            chunkSize: this.config.loadBetsCount,
            betCardData: this.betCardData,
            setIsExpanded: this.setIsExpanded,
            shareBetHandler: this.shareBet,
            currentFilter: this.config.statusFilterKeys[this.selectedStatusFilterIndex],
        });
    }
    setActualChunkHeight(index, newChunkHeight) {
        const newHeight = isNaN(newChunkHeight) ? 0 : newChunkHeight;
        if (newHeight > 0 && this.chunkHeights[index] !== newHeight) {
            this.chunkHeights.set(index, Math.ceil(newHeight));
        }
    }
    setIsExpanded(betId) {
        this.betCardData.set(betId, !this.betCardData.get(betId));
    }
}
//# sourceMappingURL=MyBetsListState.js.map